module.exports = __webpack_public_path__ + "img/icon_expiring_policy.7efff77c.png";